const en = {
  button:{
    add: 'ADD',
    create: 'CREATE',
    delete: 'DELETE',
    search: 'SEARCH',
    back: 'BACK',
    save: 'SAVE',
    edit: 'EDIT',
    update: 'UPDATE',
    logout: 'LOGOUT',
    export: 'EXPORT',
    exportXLS: 'EXPORT XLS',
    exportXLSX: 'EXPORT XLSX',
    exportCSV: 'EXPORT CSV',
    exportPDF: 'EXPORT PDF',
    reset: 'RESET',
    block: 'BLOCK',
    cancel: 'CANCEL',
    approve: 'APPROVE',
    reject: 'REJECT',
    check: 'CHECK',
    recommend: 'RECOMMEND',
    reAmend: 'RE-AMEND',
    upload: 'UPLOAD',
    reWork: 'RE-WORK',
    download: 'DOWNLOAD',
    rerun: 'RERUN',
    requestDownload: 'REQUEST DOWNLOAD',
    assignee: 'ASSIGNEE',
    close: 'CLOSE',
    assign: 'ASSIGN',
    submit: 'SUBMIT',
    next: 'NEXT',
    send: 'SEND',
    reply: 'REPLY'
  },
  label: {
    designation: 'Designation',
    employerAddress: 'Employer Address',
    referenceNumber: 'Reference Number',
    reviewDate: 'Review Date',
    reviewBy: 'Review By',
    verificationScore: 'Biometric Score',
    smartIdCardFront: 'Smart ID Card Front',
    smartIdCardBack: 'Smart ID Card Back',
    smartIdPhoto: 'Smart ID Photo',
    photoSelfie: 'Photo Selfie',
    liveness: 'Liveness',
    mobileNo: 'Mobile No.',
    emailAddress: 'Email Address',
    mailingCity: 'City',
    mailingDistrict: 'District',
    mailingAddress: 'Address',
    mailingPostalCode: 'Postcode',
    authenticityScore: 'Authenticity Score',
    countryCode: 'Country Code',
    passportNumber: 'Passport Number',
    dateOfIssue: 'Date Of Issue',
    document: 'DOCUMENT',
    releaseDate: 'Release Date',
    expiryDate: 'Expiry Date',
    religion: 'Religion',
    bloodType: 'Blood Type',
    race: 'Race',
    occupation: 'Occupation',
    address: 'Address',
    incomeRange: 'Income Range',
    city: 'City',
    district: 'District',
    postcode: 'postcode',
    submitDate: 'Submit Date',
    ICNumber: 'IC Number',
    startExpiryDate: 'Start Expiry Date',
    endExpiryDate: 'End Expiry Date',
    notes: 'Notes',
    image: 'Image',
    application: 'Application',
    financialAdvisorSubmitDate: 'Financial Advisor Submit Date',
    serialNumFNA: 'Serial Num. FNA',
    minScore: 'Min Score',
    maxScore: 'Max Score',
    fixedIncome: 'Fixed Income',
    equities: 'Equities',
    productRecommendation: 'Single Product Recommendation',
    productName: 'Product Name',
    paymentMode: 'Payment Mode',
    timeHorizon: 'Time Horizon',
    productRisk: 'Product Risk',
    financialObjectiveType: 'Financial Objective Type',
    productClass: 'Product Class',
    to: 'To',
    customer: 'Customer',
    attachment: 'Attachment',
    filter: 'Filter',
    code: 'Code',
    name: 'Name',
    phoneCode: 'Phone Code',
    phoneNumber: 'Phone Number',
    description: 'Description',
    symbol: 'Symbol',
    transactional: 'Is Transactional',
    date : 'Date',
    dateFrom : 'Date From',
    dateTo : 'Date To',
    export : 'Export Report',
    status : 'Status',
    transactionDate : 'Transaction Date',
    transactionType : 'Transaction Type',
    referenceNo : 'Reference No',
    dateCreated : 'Date Created',
    account : 'Account',
    accountNo : 'Account No',
    cardNumber: 'Card Number',
    cardType: 'Card Type',
    prepaidCard: 'Prepaid Card',
    cardStatus: 'Card Status',
    reason: 'Reason',
    username: 'Username',
    email: 'Email',
    fromAccount: 'From Account',
    toAccount: 'To Account',
    fromCurrency: 'From Currency',
    toCurrency: 'To Currency',
    amount: 'Amount',
    dateTransaction: 'Date Transaction',
    createdBy: 'Created By',
    object: 'Object',
    value: 'Value',
    modifiedBy: 'modifiedBy',
    propName: 'Property Name',
    oldValue: 'Old Value',
    newValue: 'New Value',
    cifId: 'CIF ID',
    accountType: 'Account Type',
    iSprintId: 'iSprint ID',
    walletCifId: 'Wallet Account',
    tokenStatus: 'TokenStatus',
    limitTransaction: 'Limit Transaction',
    usageOverseas: 'Usage Overseas',
    card: 'Card',
    wallet: 'Wallet',
    infoDetails: 'Info Details',
    activity: 'Activity',
    sms: 'SMS',
    customerType: 'Customer Type',
    transaction: 'Transaction',
    pricing: 'Pricing',
    startTime: 'Start Time',
    cutOff: 'Cut Off',
    url: 'Url',
    time: 'Time',
    details: 'Details',
    type: 'Type',
    flag: 'Flag',
    nationality: 'Nationality',
    userId: 'User ID',
    role: 'Role',
    cardLimit: 'Card Limit',
    dailyLimit: 'G3 Outgoing Daily Limit',
    toChange: 'to change',
    lng: 'Longitude',
    lat: 'Latitude',
    hostCode: 'Host Code',
    errorCode: 'Error Code',
    custMessage: 'Customer Message',
    minLimit: 'Min Limit/Day',
    maxLimit: 'Max Limit/Day',
    defaultLimit: 'Default Limit/Day',
    loginHistory: 'Login History',
    loginTime: 'Login Time',
    logoutTime: 'Logout Time',
    parent: 'Parent',
    parentMenu: 'Menu Parent',
    host: 'Host',
    idNumber: 'ID No',
    birthDate: 'Date of Birth',
    gender: 'Gender',
    postalCode : 'Postal Code',
    proxyNumber: 'Proxy Number',
    historyOnboarding: 'History Onboarding',
    fromStage: 'From Stage',
    toStage: 'To Stage',
    fromUser: 'From User',
    toUser: 'To User',
    dateNTime: 'Date & Time',
    solution: 'Solution',
    notifType: 'Type Notification',
    parameter: 'Parameter',
    subject: 'Subject',
    text: 'Text',
    inApp: 'In-App',
    isoCode : 'ISO',
    menuTree: 'Tree of Menu',
    agent: 'Agent',
    delete: 'Delete',
    eventCode:'Event Code',
    startDate:'Start Date',
    endDate:'End Date',
    eventName:'Event Name',
    location:'Location',
    agentCode:'Agent Code',
    agentName:'Agent Name',
    assignedAgent:'Assigned Agent',
    id: 'ID',
    docSupportId: 'Doc. Support Identification',
    docSupportFace: 'Doc. Support Face Comparison',
    comment: 'Comment',
    no: 'No',
    point: 'Point',
    module: 'Module',
    summary: 'Summary',
    custInformation: 'Customer Information',
    biometric: 'Biometric',
    docSupport: 'Document Support',
    uploadFile: 'Upload File',
    uploadDate: 'Upload Date',
    fileName: 'File Name',
    fileSize: 'File Size',
    stage: 'Stage',
    uploadBy: 'Upload By',
    companyName: 'Company Name',
    mobileFlag: 'Show at Mobile Application',
    arrivalDate: 'Task Arrival Date',
    custID: 'Customer ID',
    custName: 'Customer Name',
    waitTime: 'Wait Time',
    custSubmitDate: 'Customer Submit Date',
    taskStage: 'Task Stage',
    unit: 'Unit',
    cifKey: 'CIF Key',
    walletAccountNumber: 'Wallet Account Number',
    employeeStatus: 'Employee Status',
    employeName: 'Employer\'s Name',
    employee: 'Employee',
    incomeLevel : 'Income Level',
    fromAmount: 'From Amount',
    toAmount: 'To Amount',
    action: 'Action',
    assignee: 'Assignee',
    docShare: 'Doc Share',
    totalUsed: 'Total Used',
    year: 'Year',
    month: 'Month',
    period: 'Period',
    dailyReport: 'Daily Report',
    monthlyReport: 'Monthly Report',
    idNo: 'ID Number',
    idType: 'ID Type',
    swiftCode: 'Swift Code',
    week: 'Week',
    message: 'Message',
    banner: 'Banner',
    rewardValue: 'Reward Value',
    reward: 'Reward',
    validDay: 'Valid Day',
    taskName: 'Task Name',
    myInfoSource: 'Myinfo Source',
    nric: 'NRIC',
    alias: 'Alias',
    hanyuPinyin: 'Hanyu Pinyin',
    hanyuPinyinAlias: 'Hanyu Pinyin Alias',
    marriedName: 'Married Name',
    dob: 'Date of Birth',
    countryOfBirth: 'Country of Birth',
    block: 'Block',
    street: 'Street',
    buildingName: 'Building Name',
    floor: 'Floor',
    transactionName: 'Transaction Name',
    additionalProductInfo: 'Additional Product Info',
    productInfo: 'Product Info',
    declaration: 'Declaration',
    maritalStatus: 'Marital Status',
    fromDateApproval: 'From Date Approval',
    endDateApproval: 'End Date Approval',
    customerSegment: 'Customer Segment',
    tenure: 'Tenure',
    currency: 'Currency',
    interestRate: 'Interest Rate',
    minPlacement: 'Minimum Placement',
    effectiveDate: 'Effective Date',
    fdAccount: 'FD Account',
    certificationNumber: 'Certification Number',
    maturityInstruction: 'Maturity Instruction',
    updatedDate: 'Updated Date',
    customerName: 'Customer Name',
    oldIdNo: 'Old ID No',
    newIdNo: 'New ID No',
    billerCode: 'Biller\'s Code',
    billerName: 'Biller\'s Name',
    billerType: 'Biller\'s Type',
    fieldCode: 'Field Code',
    display: 'Display',
    index: 'Index',
    mandatory: 'Mandatory',
    dataType: 'Data Type',
    validator: 'Validator',
    billerCategory: 'Biller Category',
    inactiveFlag: 'InactiveFlag',
    dualFactor: 'Dual Factor',
    hostBillerCode: 'Host Biller Code',
    sender: 'sender',
    bankCode: 'Bank Code'
  },
  menu: {
    inquiry: {
      title: 'Inquiry',
      list: 'eKYC Inquiry',
      detail: 'Detail eKYC'
    },
    ekyc: {
      list: 'List Pending Task',
      detail: 'Detail Task',
      edit: 'Edit Task',
    },
    systemDowntime:{
      title: 'System Downtime',
      show: 'Detail System Downtime',
      edit: 'Edit System Downtime',
      notFound: 'Cannot find System Downtime with code'
    },
    estatement: {
      title: 'eStatement Maintenance',
      list: 'List eStatement Maintenance',
      create: 'Create eStatement Maintenance',
      show: 'Detail eStatement Maintenance',
      edit: 'Edit eStatement Maintenance',
      delete: 'Delete eStatement Maintenance',
      notFound: 'Cannot find eStatement Maintenance with code'
    },
    riskProfile:{
      title: 'Risk Profile',
      list: 'Risk Profile List',
      create: 'Create Risk Profile',
      show: 'Detail Risk Profile',
      edit: 'Edit Risk Profile',
      delete: 'Delete Risk Profile',
      notFound: 'Cannot find Risk Profile with code'
    },
    wealthProduct:{
      title: 'Wealth Product',
      list: 'Wealth Product List',
      create: 'Create Wealth Product',
      show: 'Detail Wealth Product',
      edit: 'Edit Wealth Product',
      delete: 'Delete Wealth Product',
      notFound: 'Cannot find Wealth Product with code'
    },
    inbox:{
      title: 'Messaging',
      list: 'Message List',
      create: 'Compose',
      show: 'Message Detail',
      upload: 'Bulk Compose',
      notFound: 'Cannot find Message with code'
    },
    country:{
      title: 'Country',
      list: 'Country List',
      create: 'Create Country',
      show: 'Detail Country',
      edit: 'Edit Country',
      delete: 'Delete Country',
      notFound: 'Cannot find country with code'
    },
    province:{
      title: 'State',
      list: 'State List',
      create: 'Create State',
      show: 'Detail State',
      edit: 'Edit State',
      delete: 'Delete State',
      notFound: 'Cannot find state with code'
    },
    city:{
      title: 'City',
      list: 'City List',
      create: 'Create City',
      show: 'Detail City',
      edit: 'Edit City',
      delete: 'Delete City',
      notFound: 'Cannot find city with code'
    },
    currency:{
      title: 'Currency',
      list: 'Currency List',
      create: 'Create Currency',
      show: 'Detail Currency',
      edit: 'Edit Currency',
      delete: 'Delete Currency',
      notFound: 'Cannot find currency with code'
    },
    financialInstitution:{
      title: 'Financial Institution',
      list: 'Financial Institution List',
      create: 'Create Financial Institution',
      show: 'Detail Financial Institution',
      edit: 'Edit Financial Institution',
      delete: 'Delete Financial Institution',
      notFound: 'Cannot find Financial Institution with code'
    },
    customerRegistered:{
      title: 'Registered Customer'
    },
    dailyCashout:{
      title: 'Daily Cashout Report'
    },
    transferList:{
      title: 'Transfer List'
    },
    reportTransactionDetail:{
      title: 'Transaction Detail'
    },
    pendingReissue:{
      title: 'Pending Re-issue Card',
      list: 'Pending Re-issue List'
    },
    transactions:{
      title: 'Transaction Inquiries',
      list: 'Transaction Inquiries List'
    },
    transactionLog:{
      title: 'Transaction Log',
      list: 'List Transaction Log'
    },
    auditTrail:{
      title: 'Audit Trail',
      list: 'Audit Trail List',
      show: 'Detail Audit',
    },
    accountEnquiries:{
      title: 'Account Inquiries',
      list: 'Account Inquiries List'
    },
    customerManagement:{
      title: 'Customer Management',
      list: 'Customer Management List',
      show: 'Detail Customer Management',
      taskList: 'List Approval Customer Info',
      detailTask: 'Detail Approval Customer Info'
    },
    custOnboarding: {
      title: 'Customer Onboarding',
      show: 'Detail Customer Onboarding',
      list: 'Customer Onboarding List'
    },
    userNotification:{
      title: 'User Profile Notification',
      list: 'Notification List'
    },
    servicePackage:{
      title: 'Service Plan',
      list: 'Service Plan List',
      create: 'Create Service Plan',
      delete: 'Delete Service Plan',
      show: 'Detail Service Plan',
      edit: 'Edit Service Plan',
      details: 'Service and Charge Pricing Details',
      notFound: 'Cannot find service with code'
    },
    sysConfig:{
      title: 'System Configuration',
      list: 'System Configuration List',
      create: 'Create System Configuration',
      show: 'Detail System Configuration',
      edit: 'Edit System Configuration'
    },
    role: {
      title: 'Role',
      create: 'Create Role',
      list: 'List Role',
      show: 'Detail Role',
      delete: 'Delete Role',
      edit: 'Edit Role'
    },
    myTask: {
      title: 'My Task',
      list: 'List My Task',
      show: 'Detail My Task'
    },
    user: {
      title: 'User',
      create: 'Create User',
      edit: 'Edit User',
      list: 'List User',
      show: 'Detail User',
      delete: 'Delete User'
    },
    branch: {
      title: 'Branch',
      create: 'Create Branch',
      edit: 'Edit Branch',
      list: 'List Branch',
      show: 'Detail Branch',
      initial: 'Initial Branch',
      delete: 'Delete Branch'
    },
    tec: {
      title: 'Transaction Error Code',
      show: 'Detail Transaction Error Code',
      description: 'Transaction Error Description',
      edit: 'Edit Transaction Error Code',
      list: 'List Transaction Error Code'
    },
    cardLimit: {
      title: 'Card Limit',
      edit: 'Edit Card Limit',
      list: 'List Card Limit',
      show: 'Detail Card Limit'
    },
    product: {
      title: 'Product',
      list: 'List Product',
      show: 'Detail Product',
      create: 'Create Product',
      edit: 'Edit Product',
      delete: 'Delete Product',
      activeCurrencies: 'List of Active Currencies',
      currencies: 'List of Currencies'
    },
    gender: {
      title: 'Gender',
      list: 'Gender List',
      show: 'Detail Gender',
      edit: 'Edit Gender',
      create: 'Create Gender',
      delete: 'Delete Gender'
    },
    notification: {
      title: 'Template Notification',
      list: 'Notification List',
      show: 'Detail Template Notification',
      edit: 'Edit Template Notification'
    },
    g3Limit: {
      title: 'G3 Outgoing Daily Limit',
      list: 'List of G3 Outgoing Daily Limit',
      edit: 'Edit G3 Outgoing Daily Limit',
      show: 'Detail G3 Outgoing Daily Limit'
    },
    dailyLimit: {
      title: 'Daily Limit',
      list: 'List of Daily Limit',
      edit: 'Edit Daily Limit',
      show: 'Detail Daily Limit'
    },
    salaryRange: {
      title: 'Salary Range',
      list: 'Salary Range List',
      show: 'Detail Salary Range',
      edit: 'Edit Salary Range',
      create: 'Create Salary Range',
      delete: 'Delete Salary Range'
    },
    occupation: {
      title: 'Occupation',
      list: 'Occupation List',
      show: 'Detail Occupation',
      edit: 'Edit Occupation',
      delete: 'Delete Occupation',
      create: 'Create Occupation'
    },
    event: {
      title: 'Event',
      list: 'List Event',
      show: 'Detail Event',
      create: 'Create Event',
      delete: 'Delete Event',
      edit: 'Edit Event',
      activeCurrencies: 'List of Active Currencies',
      currencies: 'List of Currencies'
    },
    sourceOfFund: {
      title: 'Source Of Fund',
      list: 'Source Of Fund List',
      show: 'Detail Source Of Fund',
      edit: 'Edit Source Of Fund',
      delete: 'Delete Source Of Fund',
      create: 'Create Source Of Fund'
    },
    unemployed: {
      title: 'Unemployed',
      list: 'Unemployed List',
      show: 'Detail Unemployed',
      edit: 'Edit Unemployed',
      delete: 'Delete Unemployed',
      create: 'Create Unemployed'
    },
    sourceOfWealth: {
      title: 'Source of Wealth',
      list: 'Source of Wealth List',
      show: 'Detail Source of Wealth',
      edit: 'Edit Source of Wealth',
      create: 'Create Source of Wealth',
      delete: 'Delete Source of Wealth'
    },
    natureOfBusiness: {
      title: 'Nature of Business',
      list: 'Nature of Business List',
      show: 'Detail Nature of Business',
      edit: 'Edit Nature of Business',
      create: 'Create Nature of Business',
      delete: 'Delete Nature of Business'
    },
    agent: {
      title: 'Agent Management',
      list: 'Agent Management List',
      show: 'Detail Agent Management',
      edit: 'Edit Agent Management',
      create: 'Create Agent Management',
      delete: 'Delete Agent Management'
    },
    alert:{
      title: 'Alert Category',
      list: 'Alert Category List',
      create: 'Create Alert Category',
      show: 'Detail Alert Category',
      edit: 'Edit Alert Category',
      delete: 'Delete Alert Category'
    },
    flowOnboarding: {
      titleScreening: 'Name Screening',
      custIdentification: 'CUSTOMER IDENTIFICATION',
      identification: 'IDENTIFICATION',
      passport: 'PASSPORT',
      identificationType: 'IDENTIFICATION TYPE',
      passportExpiry: 'PASSPORT EXPIRY',
      permutation: 'PERMUTATION/(S)',
      hit: 'HIT',
      noHit: 'NO HIT',
      dob: 'DOB',
      gender: 'GENDER',
      cob: 'COUNTRY OF BIRTH',
      nationality: 'NATIONALITY',
      residentialAddress: 'RESIDENTIAL ADDRESS',
      mailingAddress: 'MAILING ADDRESS',
      proofOfResidence: 'PROOF OF RESIDENCE',
      decisionPoint: 'DECISION POINT',
      reviewer2Comment: 'REVIEWER 2 COMMENT',
      reviewer1Comment: 'REVIEWER 1 COMMENT',
      photoDoc: 'PHOTO NRIC / MYKAD / PASSPORT',
      faceComparison: 'FACE COMPARISON',
      approverComment: 'APPROVER\'S COMMENT',
      doccheck: 'Doc Check',
      address: 'ADDRESS',
      countrybirth: 'COUNTRY OF BIRTH',
      idandpassport: 'IDENTIFICATION / PASSPORT',
      fullname: 'FULL NAME',
      address1: 'ADDRESS LINE 1',
      address2: 'ADDRESS LINE 2',
      address3number: 'ADDRESS LINE 3 UNIT NUMBER',
      postalcode: 'POSTAL CODE',
      country: 'COUNTRY',
      state: 'STATE',
      city: 'CITY',
      workflowAction: 'WORKFLOW ACTION',
      passportExp:'PASSPORT EXPIRY',
      uploadDocSupport:'UPLOAD SUPPORTING DOCUMENT',
      workAction:'WORKFLOW ACTION',
      uploadedDoc: 'UPLOADED DOCUMENT',
      gpsCoordinate: 'Onboarding GPS Coordinate',
      latlong: 'Latitude / Longitude',
      blacklisted: 'BLACKLISTED',
      customerType: 'CUSTOMER TYPE',
    },
    scoringMaintenance: {
      title: 'Scoring Maintenance',
      list: 'Scoring Maintenance List',
      edit: 'Edit Scoring Maintenance',
      show: 'Detail Scoring Maintenance'
    },
    myTaskOnboarding: {
      title: 'My Task Onboarding',
      notFound: 'Cannot find task with code'
    },
    myTaskEApplication: {
      title: 'My Task E-Application',
      notFound: 'Cannot find task with code'
    },
    transactionRerun: {
      title: 'Transaction Rerun',
      list: 'Transaction Rerun List'
    },
    taskRouting: {
      title: 'Task Routing'
    },
    reportStatus: {
      title: 'Report Status',
      list: 'Report Status List'
    },
    reportRoadshow: {
      title: 'Report Roadshow',
      list: 'Report Roadshow List'
    },
    reportTotalCustomer: {
      title: 'Report Total Customer'
    },
    reportOnboardingStatus: {
      title: 'Report Onboarding Status'
    },
    reportOnboardingSummary: {
      title: 'Report Onboarding Summary'
    },
    reportDNC: {
      title: 'DNC Report'
    },
    weeklyReport: {
      title: 'Weekly FX Alert Set'
    },
    nameScreening: {
      title: 'Sanction Screening Report'
    },
    campaign: {
      title: 'Campaign',
      list: 'Campaign Detail List',
      show: 'Detail Campaign',
      edit: 'Edit Campaign',
      create: 'Create Campaign',
      delete: 'Delete Campaign'
    },
    friendReferral: {
      title: 'Friend Referral Report'
    },
    referralPromoTopUp: {
      title: 'Referral Promo Top Up Report'
    },
    reportMonthlyProductivity: {
      docCheck: 'Monthly Productivity - Doc Check',
      aml: 'Monthly Productivity - AML'
    },
    crsReport: {
      title: 'Report CRS'
    },
    custParticular: {
      title: 'Report Customer Particular'
    },
    fnaApplication: {
      title: 'FNA Application Report'
    },
    fdPlacementReport: {
      title: 'FD Placement Report'
    },
    interestRate:{
      title: 'Fixed Deposit Interest Rate',
      list: 'Fixed Deposit Interest Rate List',
      create: 'Create Fixed Deposit Interest Rate',
      show: 'Detail Fixed Deposit Interest Rate',
      edit: 'Edit Fixed Deposit Interest Rate',
      duplicate: 'Duplicate Fixed Deposit Interest Rate',
      notFound: 'Cannot find Fixed Deposit Interest Rate with code'
    },
    biller:{
      title: 'Biller',
      list: 'Biller List',
      create: 'Create Biller',
      show: 'Detail Biller',
      edit: 'Edit Biller',
      notFound: 'Cannot find Biller with code'
    },
    billerCategory:{
      title: 'Biller Category',
      list: 'Biller Category List',
      create: 'Create Biller Category',
      show: 'Detail Biller Category',
      edit: 'Edit Biller Category',
      notFound: 'Cannot find Biller Category with code'
    },
    custExperienceReport: {
      title: 'Customer Experience Report'
    },
    custLoginReport: {
      title: 'Customer Login Report'
    },
    broadcastMessage: {
      title: 'Broadcast Message',
      create: 'Create Broadcast Message'
    }
  },
  error:{
    notFound: 'Cannot find data',
    badRequest: 'Oops data is already exist',
    internal: 'Oops something went wrong',
    conflict: 'Oops data is already exist',
    workflow: 'Pending task in workflow',
    exist: 'Oops data is already exist',
    validationError: 'Oops validation error',
    requiredMenuTree: 'At least one menu needed!',
    noService: 'Service not available',
    expiredToken: 'Your token has expired, please login again',
    accessDenied: 'You don\'t have access on this page',
    routing: 'Routing task failed'
  },
  errorWF: {
    failedStart: 'Failed to start Workflow',
    taskNotFound: 'Task Not Found',
    taskNotAvailable: 'Task is not available for current user',
    errorSystem: 'System encountered some error',
    notFound: 'Workflow not found',
    notSupport: 'Task Type is not supported',
    existObject: 'This code is being processed approval',
    keyNotFound: 'Key not found in object',
    existObjectKey: 'This code is being processed approval',
    failedObjToJSON: 'Object to JSON failed',
    failedJSONObjToJSONStr : 'JSON Object to JSON String failed',
    objClassNotFound: 'Object Class not found',
    failedConstructObject: 'Failed to Construct Object',
    failedDocUpload: 'Filename doesn\'t comply with the rule'
  },
  success:{
    create: 'Success create new data',
    update: 'Success update data',
    delete: 'Success delete data',
    waiting: 'Waiting for approval',
    rejected: 'This task was rejected',
    approve: 'Success approve task',
    rework: 'This task was re-work',
    rerun: 'Success re-run transaction',
    submit: 'Success submit data',
    export: 'Success export data',
    routing: 'Success routing task',
    block: 'Success block data ',
    unblock: 'Success unblock data ',
    reset: 'Success reset password data ',
    uplift: 'Successfully uplift transaction limit'
  },
  text: {
    confirmDelete: 'Are you sure to delete this data ?',
    required: 'This field is required',
    number: 'This field contains only numbers',
    empty: 'No data found',
    choose: 'Select options',
    notifSet: 'Notification Setting',
    errorSpecialChar: 'Can\'t contain',
    confirmApprove: 'Are you sure to approve this task ?',
    confirmReject: 'Are you sure to reject this task ?',
    phoneNumber: 'Format Phone Number : Country Code + Phone Number',
    countryCode: 'Country code is required',
    confirmRework: 'Are you sure to re-work this task ?',
    confirmRecommend: 'Are you sure to recommend this task ?'
  }
};

export default en;
